import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { filter, pluck } from "rxjs/operators";
import { SessionStorageService } from '../storage/sessionStorage.service';
import { LocalService } from '../storage/localService';
import { Fondo } from 'app/models/Fondo';
import { Garantia } from 'app/models/Garantia';
import {
  DiasSemana,
  Meses,
  Estados,
  Monedas,
  TiposFondo,
  TiposFrecuenciaPago,
  TiposLinea,
  TiposLineaGarantia,
  TiposTasa,
  TiposReglas,
  CategoriasRegla,
  CriteriosComparacionRegla,
  TablasRegla,
  ACCION_GARANTIA
} from "../../models/UtilGestionFondo";


@Injectable({
  providedIn: 'root'
})
export class RiesgoService {
  header: HttpHeaders;
  datos: any;
  contactoEmpresa: any;
  idEmpresa_Factor: any;
  message: Observable<any>;

  dataSector: any;

  flagCrear: boolean;
  flagEditar: boolean;
  flagVer: boolean;
  dataFondo: Fondo;
  dataGarantia: Garantia;

  DiasSemana = DiasSemana;
  Meses = Meses;
  Estados = Estados;
  Monedas = Monedas;
  TiposFondo = TiposFondo;
  TiposFrecuenciaPago = TiposFrecuenciaPago;
  TiposLinea = TiposLinea;
  TiposLineaGarantia = TiposLineaGarantia;
  TiposTasa = TiposTasa;
  TiposReglas = TiposReglas;
  CategoriasRegla = CategoriasRegla;
  CriteriosComparacionRegla = CriteriosComparacionRegla;
  TablasRegla = TablasRegla;
  dataExcepciones:any = 0;
  readonly urlBase = environment.rutaBase;

  constructor(private http: HttpClient, private accesoService: AccesoService, private sessionStorageService: SessionStorageService, private localService: LocalService) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage()
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  riesgoRUC(data: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/riesgo/ruc?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });
  }

  obtenerDNI(data: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/ObtenerDNI?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });
  }

  obtenerScore(data: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/Score?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });
  }

  RiesgoRUCTotal(data: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/riesgo/ruc?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });
  }

  //APIS RIESGO
  FiltrosEmpresaRiesgo() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ObtenerTop10k?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }

  ListadoExcepciones() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ObtenerExcepciones?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }

  RegistrarExcepcion(body: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/crearExcepciones?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
  }

  EditarExcepcion(body: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/editExcepciones?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
  }

  obtenerFondos() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/fondo?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }

  ListarSectores() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/sector?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }
  ListarGarantias() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/garantia?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }

  AsignarFondosDN(body: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/asignarFondoDN?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
  }

  LiberarFondoDN(body: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/liberarFondoDN?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
  }

  ActualizarFondosDN(body: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/actualizarFondoDN?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
  }

  ObtenerDetalleDNFondo(idComprobante) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/obtenerDetalleDNFondo?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`, { headers })
  }

  listarConcentracionAdquirente() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/concentracionAdquirente?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }
  VerConcentracionAdquirente(idAdquiriente: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/detalleConcentracionAdquirente/${idAdquiriente}?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }
  listarFinanciamientoSector() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/financiamientoSector?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
  }
  retirarFondoDN(body) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/retirarFondoDN?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
  }
  /* GESTIÓN DE FONDOS */

  obtenerInversionistasFondoRiesgo() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/fondoInversionista?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  obtenerSectoresEconomicos() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/sector?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  obtenerLineasFondo() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/lineaFondo?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  obtenerSectoresFondo() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/sectorFondo?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  registrarFondo(bodyFondo: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/fondo?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyFondo, { headers });
  }

  actualizarFondo(nroForm: number, bodyFondo: any, idFondo: any, idLineaFondo?: any) {
    let headers = this.header;
    let url = this.urlBase;
    if (nroForm == 1) {
      url = url.concat(`/fondo/${idFondo}?idEmpresa_Factor=${this.idEmpresa_Factor}`);
    }
    return this.http.put(url, bodyFondo, { headers });

  }

  crearLineafondo(bodyLineaFondo: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/lineaFondo?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyLineaFondo, { headers });
  }

  agregarListaLineasFondo(bodyLineaFondo: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/lineaFondoList?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyLineaFondo, { headers });
  }

  actualizarLineaYFrecuenciaFondo(bodyFondo: any, idLineaFondo: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', '0UVrMleeNchJEngnX8FZwIfUS');
    return this.http.put(`http://localhost:2525/api-riesgo/lineaFondo/${idLineaFondo}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyFondo, { headers });
    //let headers = this.header;
    //return this.http.put(`${this.urlBase}/lineaFondo/${idLineaFondo}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyFondo, { headers });
  }

  crearSectorFondo(bodyFondo: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/sectorFondo?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyFondo, { headers });
  }

  actualizarSectorFondo(bodyFondo: any, idFondo: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/sectorFondo/${idFondo}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyFondo, { headers });
  }

  /* NO SE USA, POR AHORA
  actualizarReglasFondo(bodyFondo: any, idFondo: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'CNMZZ4jg24QMtNhh');
    return this.http.put(`http://localhost:2525/api-riesgo/fondoReglas/${idFondo}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyFondo, { headers });
  }
  */

  cambiarEstadoFondo(bodyFondo: any, idFondo: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/fondo/${idFondo}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyFondo, { headers });
  }

  /* GESTIÓN DE GARANTÍAS */
  obtenerGarantias() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/garantia?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  registrarGarantia(bodyGarantia: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/garantia?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyGarantia, { headers });
  }

  obtenerLineasGarantia() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/lineaGarantia?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  crearListLineaGarantia(bodyLineaGarantia: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/lineaGarantiaList?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyLineaGarantia, { headers });
  }

  actualizarGarantia(nroForm: number, bodyGarantia: any, idGarantia: any) {
    let headers = this.header;
    let url = this.urlBase;
    if (nroForm == ACCION_GARANTIA.MODIFICAR_DATOS_GARANTIA) {
      url = url.concat(`/garantia/${idGarantia}?idEmpresa_Factor=${this.idEmpresa_Factor}`);
    }
    return this.http.put(url, bodyGarantia, { headers });
  }

  cambiarEstadoGarantia(bodyGarantia: any, idGarantia: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/garantia/${idGarantia}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyGarantia, { headers });
  }

  CrearSector(body) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/sector?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  ActualizarSector(body, idSector) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/sector/${idSector}?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers });
  }

  /* CONFIGURACIÓN DE RIESGO */

  obtenerReporte() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/reportecartera?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=0`, { headers });
  }

  obtenerReporteFiltros(datos : any) {
    let headers = this.header;
    console.log();
    return this.http.get(`${this.urlBase}/reportecartera?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=0&estado=${datos.estado}&numero=${datos.numero}&proveedor=${datos.proveedor}&adquirente=${datos.adquirente}&adquirente=${datos.Tipo_Emision}`, { headers });
  }
  asignarSectorEmpresa(data: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/sectorEmpresa?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers });
  }
  actualizarDocumento(body:any,idComprobante:any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/reportecartera/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body, { headers });
  }
  reactivarDocumento(body:any,idComprobante:any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/reactivar/${idComprobante}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body, { headers });
  }
  //Especial ACFIN
  agregarProcesoCorte(body : any){
    let headers = this.header; 
   return  this.http.post(`${this.urlBase}/acfin/corte?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
  }
  obtenerProcesosACFIN(datos : any) {
    let headers = this.header; 
    return this.http.get(`${this.urlBase}/acfin/corte?idEmpresa_Factor=${this.idEmpresa_Factor}&estado=${datos.Estado}&codigo=${datos.CodOperacion}&fecha=${datos.FechaIni}`, { headers });
  }
  enviarProcesoACFIN(datos : any,idProceso){
    let headers = this.header; 
    return  this.http.post(`${this.urlBase}/acfin/send/${idProceso}?idEmpresa_Factor=${this.idEmpresa_Factor}`,datos,{headers})
  }
}

